import type { UUID } from "@/core/types";

export const draftNotesKeys = {
  base: ["draft-notes"] as const,
  list: (providerId?: UUID) => [...draftNotesKeys.base, "list", providerId] as const,
} as const;
